const {
  runAllExtenders: baseRunAllExtenders
} = require("vue-extender");

import moment from "moment";
import cryptoJS from "crypto-js";
import global from "../global";
import userManager from "../userManager";

const runAllExtenders = (Vue) => {
  baseRunAllExtenders(Vue);

  Vue.defineFields(cryptoJS.enc.Base64, {
    "encode": (rawStr, encoding = cryptoJS.enc.Utf8) => {
      let wordArray = encoding.parse(rawStr);
      return cryptoJS.enc.Base64.stringify(wordArray);
    },
    "decode": (base64Str, encoding = cryptoJS.enc.Utf8) => {
      let wordArray = cryptoJS.enc.Base64.parse(base64Str);
      return wordArray.toString(encoding);
    }
  });

  Vue.defineProperties(Vue.prototype, {
    "$moment": {
      get() {
        return moment;
      }
    },
    "$cryptoJS": {
      get() {
        return cryptoJS;
      }
    },
    "GLOBAL": {
      get() {
        return global;
      }
    },
    "USERMANAGER": {
      get() {
        return userManager;
      }
    }
  });
};

export {
  runAllExtenders
};

export default {
  install(Vue) {
    runAllExtenders(Vue);
  }
};



// WEBPACK FOOTER //
// ./src/core/vue-extender/index.js